<template>
  <v-container fluid>
    <v-toolbar flat color="white mb-2">
      <h3 class="mr-4">Discord予約投稿一覧</h3>

      <v-btn @click="newItem" color="primary">+ 新規作成</v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="25"
      sort-by="id"
      sort-desc
      :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
    >
      <template v-slot:item.id="{ item }">
        <div @click="detail(item)" text>{{ item.id }}
        <v-icon small color="primary" @click="detail(item)">fas fa-edit</v-icon>
        </div>
      </template>

      <template v-slot:item.avatar_url="{ item }">
        <img
          v-if="item.avatar_url != ''"
          :src="item.avatar_url"
          width="40"
          height="40"
        />
      </template>

      <template v-slot:item.delete_flg="{ item }">
        <v-chip v-if="item.delete_flg == 0" class="chips orange white--text"
          >投稿予定</v-chip
        >
        <v-chip v-else class="chips">投稿済み</v-chip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  data() {
    return {
      headers: [
        { text: "id", value: "id", width: "60px", align: "center" },
        // { text: "webhooks_url", value: "webhooks_url", width: "100px" },

        {
          text: "avatar_url",
          value: "avatar_url",
          width: "100px",
          align: "center",
        },

        { text: "投稿者名", value: "username", width: "100px" },
        { text: "投稿時間", value: "reserve_time", width: "200px" },
        { text: "delete_flg", value: "delete_flg", width: "100px" },
      ],

      //ここに変数や定数を定義
      itemsPerPageArray: [32, 64, 128],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 32,
      sortBy: "name",
      keys: ["Id", "username", "category"],
      items: [],
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== `Name`);
    },
  },
  methods: {
    detail(item) {
      this.$router.push({
        name: "discordPostDetail",
        params: { id: item.id },
      });
    },

    newItem() {
      this.$router.push({
        name: "discordPostDetail",
        params: { id: -1 },
      });
    },

    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    navigateProductDetail(appli) {
      //現在の表示数・ページ番号を保存
      this.$store.commit("updateAppLiPage", this.page);
      this.$store.commit("updateAppLiPerPage", this.itemsPerPage);

      this.$router.push({
        name: "appliDetails",
        params: { id: appli.id },
      });
    },

    customFilter(items, search) {
      //search = search.toString().toLowerCase()
      // console.log(items)

      if (search == null) {
        search = "";
      }

      var tmp = [];

      items.forEach((element) => {
        if (element["title"].indexOf(search) != -1) {
          tmp.push(element);
        } else if (element["sub_title"].indexOf(search) != -1) {
          tmp.push(element);
        } else if (element["id"].indexOf(search) != -1) {
          tmp.push(element);
        }
      });

      return tmp;

      // return items.filter(row => this.filter(row["season"], search));
    },
  },

  created: function() {
    axios.get(process.env.VUE_APP_Discord_POST_LIST).then((response) => {
      console.log(response);
      // v-data-tableを使うときは配列に格納する
      // const items = [];
      const values = Object.values(response.data);
      values.forEach((value) => {
        const item = {
          id: value.id,
          webhooks_url: value.webhooks_url,
          avatar_url: value.avatar_url,
          username: value.username,
          reserve_time: value.reserve_time,
          delete_flg: value.delete_flg,
        };
        this.items.push(item);
      });
      // this.list = items;
    });
  },
};
</script>

<style></style>
